import React, { CSSProperties, memo, useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { StarOutlined, StarFilled } from '@ant-design/icons';
import { Button, message } from 'antd';
import { useRequest } from 'ahooks';
import { RootState } from '@/models';
import { ConBrandDetailsWebController } from '@/services/swagger/ConBrandDetailsWebController';
import styles from './index.module.scss';

export type BrandCollectionButtonProps = {
  brandId?: string;
  active?: boolean;
  className?: string | undefined;
  style?: CSSProperties | undefined;
  onChange?: (value: boolean) => void;
};
const controller = new ConBrandDetailsWebController();

const BrandCollectionButton: React.FC<BrandCollectionButtonProps> = ({
  brandId,
  active,
  className,
  style,
  onChange,
}) => {
  const { token } = useSelector((state: RootState) => state.user);
  const { run } = useRequest(
    async () => {
      const res = await controller.conBrandDetailsWebControllerV1CollectBrandUsingPut1({
        conBrandId: brandId,
        operFlag: !active,
      });
      return res.data;
      ``;
    },
    {
      manual: true,
      onSuccess(res) {
        if (res.code !== 200) {
          message.error(res.msg);
          return;
        }
        onChange?.(!active);
        message.success(res.msg);
      },
    }
  );
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    if (!token) {
      dispatch({ type: 'modal/openUserLoginModal', payload: 'login' });
    } else {
      run();
    }
  }, [dispatch, run, token]);

  return (
    <Button
      className={classNames(styles.btn, active ? styles.active : styles.inactive, className)}
      style={style}
      icon={active ? <StarFilled /> : <StarOutlined />}
      type="text"
      onClick={onClick}
    >
      {active ? '取消收藏' : '收藏品牌'}
    </Button>
  );
};

export default memo(BrandCollectionButton);
